module.exports = __webpack_public_path__ + "static/media/Checklist.5f81a969.svg";